/**
 * The save button's label, measured (B6 §2): on the board's **default** table view monday
 * writes **`Save as new view`** — there is no `BoardView` row to save into, because "Main
 * table" is not one. On a saved view the same button saves in place.
 */
import { useTable } from '../context';

export function useSaveLabel(): string {
  const payload = useTable((state) => state.payload);
  const view = (payload?.views ?? []).find((entry) => entry.id === payload?.view.id);
  return view && view.isDefault === false ? 'Save to this view' : 'Save as new view';
}
